import { render, staticRenderFns } from "./SuppliersSideMenu.vue?vue&type=template&id=50e43365&scoped=true&"
import script from "./SuppliersSideMenu.vue?vue&type=script&lang=js&"
export * from "./SuppliersSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersSideMenu.vue?vue&type=style&index=0&id=50e43365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e43365",
  null
  
)

export default component.exports